var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-text',{attrs:{"id":"itemEndDateInputLiveHelp"}},[_vm._v(" Hora inicial do ciclo diário de irrigação ")]),_c('b-form-select',{attrs:{"options":_vm.startHourOptions,"size":"sm"},model:{value:(_vm.startHour),callback:function ($$v) {_vm.startHour=$$v},expression:"startHour"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }